import React from "react";
import { FaPlane, FaDatabase, FaFilm, FaUsers, FaLeaf, FaTrain, FaHorse, FaSubway } from "react-icons/fa";
import '../Wnoida/Wnoida.css';

const WnoidaSection = () => {
  const data = [
    {
      icon: <FaPlane />,
      title: "Jewar International Airport",
      description: "Foundation laid with an estimated investment of Rs. 30,000 cr",
    },
    {
      icon: <FaDatabase />,
      title: "Data Centres Investment",
      description: "Over Rs. 22,000 cr proposed for setting up data centres in Noida",
    },
    {
      icon: <FaFilm />,
      title: "Film City",
      description: "Rs. 10,000 cr Film City is proposed across Yamuna Expressway",
    },
    {
      icon: <FaUsers />,
      title: "Housing Development",
      description: "Greater Noida (West) expected to have 5 lakh apartments, 12 lakh residents",
    },
    {
      icon: <FaLeaf />,
      title: "Green Cover",
      description: "With over 25% area under green cover, one of the most promising cities to live in",
    },
    {
      icon: <FaHorse />,
      title: "Toy City",
      description: "Over Rs. 400 cr Toy City to be set up near Jewar – an alternate to Chinese toy industry",
    },
    {
      icon: <FaTrain />,
      title: "Delhi-Noida-Varanasi Bullet Train",
      description: "Proposed bullet train likely to be completed by 2029-30",
    },
    {
      icon: <FaSubway />,
      title: "Aqua Metro Line",
      description: "Extension of Aqua Metro Line will help lakhs of commuters in Greno West",
    },
  ];

  return (
    <section className="wnoida-section">
      <h1>Why Greater Noida West?</h1>
      <h2>Because sometimes, location is everything.</h2>
      <div className="wnoida-grid">
        {data.map((item, index) => (
          <div key={index} className="wnoida-card">
            <div className="icon">{item.icon}</div>
            <div className="text">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WnoidaSection;
